import { graphql } from '@api/mesa'

export const ADD_NOTIFICATION_DEVICE = graphql(`
  mutation AddNotificationDevice(
    $os: String!
    $model: String!
    $year: String!
    $expoPushToken: String!
    $devicePushToken: String!
  ) {
    addNotificationDevice(
      input: {
        os: $os
        model: $model
        year: $year
        expoPushToken: $expoPushToken
        devicePushToken: $devicePushToken
      }
    ) {
      __typename
    }
  }
`)

export const UPDATE_NOTIFICATION_SETTINGS = graphql(`
  mutation UpdateNotificationSettings($settings: JSONObject!) {
    updateNotificationSettings(input: { settings: $settings }) {
      __typename
      ... on MesaGenericOk {
        status
      }
      ... on MesaUserError {
        message
      }
    }
  }
`)

export const UPDATE_USER_NOTIFICATION_PUSH_STATUS = graphql(`
  mutation UpdateNotificationPushStatus(
    $id: String!
    $pushNotificationStatus: UserPushNotificationStatus!
  ) {
    updateNotificationPushStatus(
      input: { id: $id, pushNotificationStatus: $pushNotificationStatus }
    ) {
      __typename
    }
  }
`)

export const UPDATE_ALL_NOTIFICATIONS_PUSH_STATUS_TO = graphql(`
  mutation UpdateAllNotificationsPushStatusTo(
    $pushNotificationStatus: UserPushNotificationStatus!
  ) {
    updateAllNotificationsPushStatusTo(input: { pushNotificationStatus: $pushNotificationStatus }) {
      __typename
    }
  }
`)
